import React, { useState } from "react";
import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import { queryClient } from "../../router";
const ConsignmentListComponent = loadable(
  () => import("../../components/Consignment/ConsignmentList")
);

export const ConsignmentList = () => {
  const [openDeletePopup, setDeletePopup] = useState(false);

  const { mutateAsync: removeitems, isPostLoading: isRemoving } = usePostHook({
    queryKey: ["pickup-request-items"],
    navigateURL: "",
  });
  const handleRemove = async (id: string) => {
    try {
      const url = `${APIS.PICKUPREQUEST}remove-draft-order/`;
      const res = await removeitems({
        url,
        formData: {
          order_ids: [id],
        },
      });
      if (res.status == 200) {
        queryClient.refetchQueries();
        setDeletePopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <ConsignmentListComponent
        handleRemove={handleRemove}
        isRemoving={isRemoving}
        setDeletePopup={setDeletePopup}
        openDeletePopup={openDeletePopup}
      />
    </>
  );
};
